import React from 'react';
import {connect} from 'react-redux';
import CustomerModel from '/app/src/model/Customer/model';
import CustomerSelector from '/app/src/model/Customer/selector';
import DateTime from '/app/src/lib/DateTime';
import {H3, Flex} from '/app/src/component'
import style from './style.css';

class CustomerStatistic extends React.Component {
    constructor(props) {
        super(props);
        this.__handleStatisticRetrieval = this.__handleStatisticRetrieval.bind(this);
        this.__statisticRetrieval = this.__statisticRetrieval.bind(this);
        this.intervalId = '';
    }
    componentDidMount(){
        let fetched = this.props.statsFetched
        let fetching = this.props.statsFetching
        let customerId = this.props.customerId
        this.__handleStatisticRetrieval(fetched, fetching, customerId)
    }

    // we dont want to keep this fetching interval
    componentWillUnmount(){
        clearInterval(this.intervalId);
    }

    // we only get the stats depends on the condition
    __statisticRetrieval(statsFetched, statsFetching, customerId){
        if(!statsFetching){
            if (statsFetched){
                // check if more than interval
                let now = new Date().toLocaleString()
                let diff = DateTime.getDiffTime(now, statsFetched)
                if(diff < this.props.interval){
                    return;
                }
            }
            this.props.dispatch(CustomerModel.readStatsFromDB(customerId))
        }
    }

    // make sure we loop the stats fetching
    __handleStatisticRetrieval(statsFetched, statsFetching, customerId) {
        this.__statisticRetrieval(statsFetched, statsFetching, customerId)
        this.intervalId = setInterval(() => {
            this.__statisticRetrieval(statsFetched, statsFetching, customerId)
        }, 600*1000);
    }

    componentWillReceiveProps(nextProps) {
        var nextCustomerId = nextProps.customerId;
        clearInterval(this.intervalId);
        this.__handleStatisticRetrieval(nextProps.statsFetched, nextProps.statsFetching, nextCustomerId)
    }

    __renderItem(title, body) {
        return (
            <Flex column width='100%'>
                <Flex className={style.StatsHeader}>
                    <H3> {title} </H3>
                </Flex >
                <Flex className={style.StatsBody}>
                    {body}
                </Flex>
            </Flex>
        )
    }

    _renderLastVisist(stats) {
        let lastVisit = stats.lastVisits[0].serverDatePretty;
        let lastDaysAgo = stats.lastVisit.daysAgo;
        let title = 'Senaste besök';
        let body = `${lastVisit}, ${lastDaysAgo} dagar sedan.`;

        return this.__renderItem(title, body)
    }

    _renderTotalTimeSpend(stats) {
        let totalVisitDuration = DateTime.convertSecondsToHour(stats.totalVisitDuration);// for miliseconds
        let title = 'Total spenderad tid på webbplatsen';
        let body = <Flex vAlignContent='center'> <img alt='clock' src='/images/Clock.png'/> &nbsp;&nbsp;&nbsp; {totalVisitDuration} </Flex>;
        return this.__renderItem(title, body);

    }

    _renderTotalPagesView(stats) {
        let totalPageViews = stats.totalPageViews;
        let title = 'Antal sidbesök';
        let body = <Flex w='100%'> {totalPageViews} </Flex>
        return this.__renderItem(title, body)
    }
    _renderTotalVisits(stats) {
        let totalVisits = stats.totalVisits;
        let title = 'Antal besök';
        let body = <Flex hAlignContent='center'> {totalVisits} </Flex>
        return this.__renderItem(title, body)

    }

    _renderLocation(stats) {
        let location = '   ' + stats.lastVisits[0].location;
        let title = <div> Plats </div>;
        let countryFlag = 'https://stats.jibber.social/' + stats.lastVisits[0].countryFlag;
        let body = <Flex>  <img src={countryFlag} alt={location}/>
            <Flex ml='4px' wordBreak='break-word'>{location}</Flex> </Flex>;
        return this.__renderItem(title, body)
    }
    _renderIp(stats) {
        let ipAddress = stats.lastVisits[0].visitIp;
        return this.__renderItem('IP-address', ipAddress)
    }
    _renderLastVisitedPages(stats) {
        let pages = [];
        let actions = stats.lastVisits[0].actionDetails;
        for (var i = 0; i < actions.length; i += 1){
            var page = actions[i].url;
            pages.push(page);
        }

        pages = pages.map((page, index) => {
            return (<Flex className={style.VisitorPathText} key={index}> {index+1}. {page} </Flex>)
        })

        return this.__renderItem("Besökarens väg", <Flex column> {pages} </Flex>);
    }

    render() {
        let customer = this.props.customer;
        let statsPayload = this.props.statsPayload;
        let statsFetched = this.props.statsFetched;
        let statsFetching = this.props.statsFetching;

        if(!customer)
            return <div> 'Kund ej funnen.' </div>;


        if(!statsFetched && statsFetching){
            return <div> </div>;
        }

        if(!statsPayload.userId){
            return <div> '' </div>;
        }

        return(
            <Flex column hAlignContent='center' w='100%' px='5%' shrink={0} color='black' overflowY='auto'>
                {this.__renderItem('Nuvarande sidan', CustomerSelector.getCurrentUrl(this.props.customer))}
                {statsFetching && (<div> {''} </div>)}
                    {this._renderLastVisitedPages(statsPayload)}

                    {this._renderLastVisist(statsPayload)}
                    {this._renderTotalTimeSpend(statsPayload)}
                    <Flex w='100%'>
                        {this._renderTotalPagesView(statsPayload)}
                        {this._renderTotalVisits(statsPayload)}
                    </Flex>


                    {this._renderLocation(statsPayload)}
                    {this._renderIp(statsPayload)}
            </Flex>
        );
    }

}

function mapStateToProps(state, props){
  const customer = props.customer
  const customerId = CustomerSelector.getId(customer)
  const stats = CustomerSelector.getStats(customer).toJS()

  return {
      customerId: customerId,
      statsFetching: stats.fetching,
      statsFetched: stats.fetched,
      statsPayload: stats.payload
  }

}

export default connect(mapStateToProps)(CustomerStatistic);



// WEBPACK FOOTER //
// ./src/container/Customer/CustomerStatistic.js